export default __webpack_public_path__ + "static/media/o-projekcie-napis_1.d8a0d9ff.jpg";